import { MutationOptions } from '@tanstack/react-query';
import { downloadZipVehiclePicturesQueryFunction } from '@/modules/FileDetail/queries/documentation/downloadZip/downloadZipVehiclePictures/downloadZipVehiclePicturesQueryFunction';
import {
  DownloadZipVehiclePicturesQueryResponseType,
  DownloadZipVehiclePicturesZipType,
} from '@/modules/FileDetail/queries/documentation/downloadZip/downloadZipVehiclePictures/downloadZipVehiclePicturesQuery.type';

export const downloadZipVehiclePicturesQueryOptions = (): MutationOptions<
  DownloadZipVehiclePicturesQueryResponseType,
  Error,
  DownloadZipVehiclePicturesZipType
> => ({
  mutationKey: ['createZipVehiclePicturesQueryOptions'],
  mutationFn: (params: DownloadZipVehiclePicturesZipType) =>
    downloadZipVehiclePicturesQueryFunction({
      id: params.id,
    }),
});
